import React, { useEffect, useState } from 'react';
import { Alert, Card } from 'tea-component';
import AnalysisLineChart from '../AnalysisLineChart';
import { namespace } from '../../model';
import { connect } from 'umi';
import { useDblIntl } from '@/pages/datalab/utils/utils';
import { isEmpty } from 'lodash-es';
import Loading from '@/pages/dashboard/components/Loadings';

export default connect((state: any) => {
  const {
    table,
    chartData,
    columnFilters,
    columnCompares,
    hadAnalysed,
    hashEqualForAnalysis,
    analysisRunning,
    analysisRefreshRunning,
    chartType,
    reqParams,
    columnDimensions,
    columnMetrics,
    columnRawColumns,
    save_column_infos: saveColumnInfos,
  } = state[namespace];

  return {
    table,
    chartData,
    columnFilters,
    columnCompares,
    hadAnalysed,
    hashEqualForAnalysis,
    analysisRunning,
    analysisRefreshRunning,
    chartType,
    reqParams,
    columnDimensions,
    columnMetrics,
    columnRawColumns,
    saveColumnInfos,
    analysisLoading: state.loading.effects[`${namespace}/getDataAnlysis`],
  };
})(GuideOperation);

function GuideOperation(props: any) {
  const {
    isShow,
    closeBtn,
    hashEqualForAnalysis,
    columnFilters,
    columnCompares,
    hadAnalysed,
    analysisRunning,
    analysisRefreshRunning,
    // analysisLoading,
  } = props;

  const {
    dblFormatMessage: multiFormatMessage,
  } = useDblIntl('multi');
  // const location = useLocation();
  // const isHistOryExplore = ['dashboardExplore', 'datalabExplore'].includes(
  //   location?.query?.from,
  // );
  
  const [compareTimeData, setCompareTimeData] = useState({});
  useEffect(() => {
    const dateFilters = columnFilters?.filter(item => item.column_type === 'date') || [];
    
    const comparefilter = dateFilters.find(filter => !isEmpty(filter?.compareTimes));
    
    if (comparefilter) {
      setCompareTimeData({
        filterId: comparefilter.id,
        defaultCompareTimes: comparefilter?.compareTimes,
        baseTimeRange: comparefilter?.column_text?.split(" ~ ") || [],
        baseTimeName: comparefilter?.column_display || comparefilter?.column_name,
        timeGranularity: comparefilter?.dateType,
      });
      return;
    }
    const dateFilter = dateFilters[0];
    setCompareTimeData({
      filterId: dateFilter?.id,
      disabled: dateFilters?.length === 0,
      defaultCompareTimes: [],
      baseTimeRange: dateFilter?.column_text?.split(" ~ ") || [],
      baseTimeName: dateFilter?.column_display || dateFilter?.column_name,
      timeGranularity: dateFilter?.dateType
    });
  }, [JSON.stringify(columnFilters || {})]);
  
  // 历史报表探索
  // const customLineShow = useMemo(() => {
  //   let isShow = false;
  //   if (!newFlag && !analysisRunning) {
  //     if ([ChartType.Line, ChartType.StackBar].includes(chartType) && !isEmpty(chartData)) {
  //       isShow = true;
  //     }
  //   }
  //   return isShow;
  // }, [analysisRunning, chartData, chartType, newFlag]);
  const isShowInfoWarn = hashEqualForAnalysis !== true && !analysisRunning && !analysisRefreshRunning;
  const isLoading = analysisRunning;
  return (
    <>
      { isShowInfoWarn ? (
        <Alert
          type="warning"
          className="multi-analysis-search-showtext"
        >
          {multiFormatMessage('calculate_info')}
        </Alert>
      ) : (
        ''
      )}
      <Card className={`guide_operation ${!hadAnalysed ? '' : 'dbl-table-multi-analysis'}`}>
        {
          isLoading ? <Loading/> :<Card.Body>
            <div className="table-analysis">
              <AnalysisLineChart namespace={namespace} isOnlyShowPie filtersArr={columnFilters} filterCompares={columnCompares} isBigBar compareTimeData={compareTimeData} setCompareTimeData={setCompareTimeData} />
            </div>
            
            {isShow ? (
              <div
                className="expand-collapse-bottom"
                onClick={() => {
                  closeBtn();
                }}
              >
                <div className="expand-collapse-init" />
              </div>
            ) : (
              ''
            )}
          </Card.Body>
        }
      </Card>
    </>

  );
}
